﻿//import Map from 'ol/Map.js';
import TileLayer from 'ol/layer/Tile.js';
import WMTS, { optionsFromCapabilities } from 'ol/source/WMTS.js';
import LayerGroup from 'ol/layer/Group';
import VectorLayer from 'ol/layer/Vector';
import OSM from 'ol/source/OSM.js';

import { getJsonSource, getIconStyle } from './vxLayerLibrary';


function getLayerByNameWMTS(layerName, wmtsCapabilities) {
    var myLayer = null;

    var myLayerTitle = null;
    var myLayerGeoServer = null;
    var myLayerType = null;

    switch (layerName) {
        case "vdaHillshade":
            myLayerTitle = 'hill_16m';
            myLayerGeoServer = 'vx3dproject:hill_16m_wgs';
            myLayerType = 'base';
            break;

        case "vdaOrto":
            myLayerTitle = "Ortofoto";
            myLayerGeoServer = "vx3dproject:OI.ORTOIMMAGINI.2012.32";
            myLayerType = 'base';
            break;

        case "vdaBordo":
            myLayerTitle = "pg_bordo_res_map_tot_wgs";
            myLayerGeoServer = "vx3dproject:pg_bordo_res_map_tot_wgs";
            break;

        case "topo_01_pl_iso_50_res_map_wgs":
            myLayerTitle = "topo_01_pl_iso_50_res_map_wgs";
            myLayerGeoServer = "vx3dproject:topo_01_pl_iso_50_res_map_wgs";
            break;

        case "topo_02_pl_idro_50_res_map_wgs":
            myLayerTitle = "	topo_02_pl_idro_50_res_map_wgs";
            myLayerGeoServer = "vx3dproject:topo_02_pl_idro_50_res_map_wgs";
            break;

        case "topo_03_pg_topo_50_res_map_wgs":
            myLayerTitle = "topo_03_pg_topo_50_res_map_wgs";
            myLayerGeoServer = "vx3dproject:topo_03_pg_topo_50_res_map_wgs";
            break;

        case "topo_03_pl_topo_50_res_map_wgs":
            myLayerTitle = "topo_03_pl_topo_50_res_map_wgs";
            myLayerGeoServer = "vx3dproject:topo_03_pl_topo_50_res_map_wgs";
            break;

        case "topo_04_pt_quotati_wgs":
            myLayerTitle = "topo_04_pt_quotati_wgs";
            myLayerGeoServer = "vx3dproject:topo_04_pt_quotati_wgs";
            break;

        case "res_dgpv_pl_wgs":
            myLayerTitle = "res_dgpv_pl_wgs";
            myLayerGeoServer = "vx3dproject:res_dgpv_pl_wgs";
            break;

        case "res_dgpv_pg_wgs":
            myLayerTitle = "res_dgpv_pg_wgs";
            myLayerGeoServer = "vx3dproject:res_dgpv_pg_wgs";
            break;

        case "res_pg_050523_wgs":
            myLayerTitle = "res_pg_050523_wgs";
            myLayerGeoServer = "vx3dproject:res_pg_050523_wgs";
            break;

        case "res_pl_050523_wgs":
            myLayerTitle = "res_pl_050523_wgs";
            myLayerGeoServer = "vx3dproject:res_pl_050523_wgs";
            break;




    };

    if (myLayerTitle != null) {
        myLayer = new TileLayer({
            title: myLayerTitle,
            opacity: 1,
            source: new WMTS(
                optionsFromCapabilities(wmtsCapabilities, {
                    layer: myLayerGeoServer,
                    matrixSet: 'EPSG:900913',
                })
            ),
            type: myLayerType,
            visible: false
        });
    }

    return myLayer;
}

//let param;
//let vxOlMap;
//let layers;
//let vdaPyrTiff
class vxVdaMap {
    //static init(myVxOlMap) {
    //    vxOlMap = myVxOlMap;
    //}
    static getBaseLayerGroup(vxOlMap) {


        const osm = new TileLayer({
            title: 'Open Street Map',
            source: new OSM(),
            opacity: 0.7,
            type: 'base',
            visible: true
        });



        // BASE-GROUP
        var vdaOrto = getLayerByNameWMTS('vdaOrto', vxOlMap.wmtsCapabilities);
        var vdaHillshade = getLayerByNameWMTS("vdaHillshade", vxOlMap.wmtsCapabilities);


        return new LayerGroup({
            title: 'Base maps',
            fold: 'open',
            layers: [osm, vdaOrto, vdaHillshade]
        });

    }

    static getCtrLayerGroup(vxOlMap) {
        //layers
        const optionsCtr = optionsFromCapabilities(vxOlMap.wmtsCapabilities, {
            layer: 'vx3dproject:CTR_50_wgs',
            matrixSet: 'EPSG:900913',
        });

        const vdaCTR = new TileLayer({
            title: 'Ctr 50.000',
            opacity: 1,
            source: new WMTS(optionsCtr),
            visible: false
        });
        return new LayerGroup({
            title: 'Ctr',
            fold: 'open',
            layers: [vdaCTR]
        });
    }

    static getTopoLayerGroup(vxOlMap) {
        // TOPO-GROUP
        var vdaBordo = getLayerByNameWMTS("vdaBordo", vxOlMap.wmtsCapabilities);
        var vdaTopo01 = getLayerByNameWMTS("topo_01_pl_iso_50_res_map_wgs", vxOlMap.wmtsCapabilities);
        var vdaTopo02 = getLayerByNameWMTS("topo_02_pl_idro_50_res_map_wgs", vxOlMap.wmtsCapabilities);
        var vdaTopo03 = getLayerByNameWMTS("topo_03_pg_topo_50_res_map_wgs", vxOlMap.wmtsCapabilities);
        var vdaTopo03b = getLayerByNameWMTS("topo_03_pl_topo_50_res_map_wgs", vxOlMap.wmtsCapabilities);
        var vdaTopo04 = getLayerByNameWMTS("topo_04_pt_quotati_wgs", vxOlMap.wmtsCapabilities);
        return new LayerGroup({
            title: 'Topo',
            fold: 'open',
            layers: [vdaBordo, vdaTopo01, vdaTopo02, vdaTopo03, vdaTopo03b, vdaTopo04]
        });
    }
    static getGeologyLayerGroup(vxOlMap) {
        // GEO-GROUP
        var vdaGeo01 = getLayerByNameWMTS("res_dgpv_pg_wgs", vxOlMap.wmtsCapabilities);
        var vdaGeo02 = getLayerByNameWMTS("res_dgpv_pl_wgs", vxOlMap.wmtsCapabilities);
        var vdaGeo03 = getLayerByNameWMTS("res_pg_050523_wgs", vxOlMap.wmtsCapabilities);
        var vdaGeo04 = getLayerByNameWMTS("res_pl_050523_wgs", vxOlMap.wmtsCapabilities);
        return new LayerGroup({
            title: 'Geo',
            fold: 'open',
            layers: [vdaGeo04, vdaGeo03, vdaGeo02, vdaGeo01]
        });
    }
    static getGigapanLayerGroup() {

        const vdaGigaPan = new VectorLayer({
            title: 'GigaPAN Point of View',
            source: getJsonSource('vx3dproject:pt_gigapan'),
            //style: getCircleStyle(10, 'blue'),
            style: getIconStyle('/images/img-markers/camera.png', 30),
            name: 'pt_gigapan'
        });
        const vdaGigaPanPoi = new VectorLayer({
            title: 'GigaPAN Point of Interest',
            source: getJsonSource('vx3dproject:v_pt_gigapan_poi'),
            //style: getCircleStyle(7, 'green'),
            style: getIconStyle('/images/img-markers/peak.png', 25),
            name: 'pt_gigapan_poi'
        });
        return new LayerGroup({
            title: 'Gigapan',
            fold: 'open',
            layers: [vdaGigaPan, vdaGigaPanPoi]
        });
    }

    static getResultDiv(feature, layername) {
        var props = feature.getProperties();
        const div = document.createElement('div');
        div.className = 'immagine-item';

        const title = document.createElement('h5');
        const img = document.createElement('img');
        const link = document.createElement('a');

        //console.log(JSON.safeStringify(layername));
        if (layername == 'pt_gigapan') {

            //console.log(JSON.safeStringify(layername));
            //console.log('count:' + i + ' id: ' + props.id);

            img.src = `/fcgi-bin/iipsrv.fcgi?FIF=${props.image_filename}.tif&HEI=200&WID=400&CVT=JPEG`;
            img.alt = props.description;
            link.href = `/Gigapan/${props.image_filename}`;
            link.title = props.description;

            title.textContent = props.description;

        }
        else if (layername == 'pt_gigapan_poi') {
            let my_x = (parseFloat(props.x_gp)) - 1024;

            let my_y = (0 - parseFloat(props.y_gp)) - 512;

            img.src = `/iiif/${props.image_filename}.tif/${my_x},${my_y},2048,1024/256,128/0/default.jpg`;
            img.alt = props.name;

            link.href = `/Gigapan/${props.image_filename}/${props.id}`;
            link.title = props.name;

            title.textContent = props.name;
        }
        else {
            console.log("layer " + layername + " is unknown ");
        }

        div.appendChild(title);

        link.appendChild(img);
        link.target = '_self';
        div.appendChild(link);
        return div;
    }

}

export default vxVdaMap;